// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4edb8e88] .article-content{padding:23px 16px 0}[data-v-4edb8e88] .footer{margin-top:24px;padding:16px 0;background:#f2f3f5;border-top:1px solid rgba(17,19,23,.05);color:#b9bdc6}", ""]);
// Exports
module.exports = exports;
